const btnConfirmCreateUser = {
  text: 'Create an account'
};

export default btnConfirmCreateUser;
